import { FILTER_TYPES } from 'components/FilterPod';
import jMoment from 'moment-jalaali';

const filters = (currencyText) => [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'شناسه محصول',
    label: 'شناسه',
    keyName: 'شناسه صنف',
    query: 'id',
    id: 1569,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      dir: 'ltr',
      englishNumber: true,
    },
  },
  {
    title: 'نام محصول',
    label: 'جستجو در نام',
    keyName: 'نام محصول',
    query: 'name',
    id: 1570,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'محدوده‌ مجموع تعداد فروش',
    label: {
      start: 'از تعداد',
      end: 'تا تعداد',
    },
    unit: 'عدد',
    keyName: 'محدوده‌ تعداد فروش',
    id: {
      start: 1571,
      end: 1572,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
        currencyText: 'عدد',
      },
      end: {
        currency: true,
        currencyText: 'عدد',
      },
    },
  },
  {
    title: 'محدوده‌ مجموع مبلغ فروش',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'محدوده‌ مجموع مبلغ فروش',
    id: {
      start: 1573,
      end: 1574,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
];

export default filters;
